module.exports = __webpack_public_path__ + "img/screen-mirroring-bg.9b786351.png";